import React, {FunctionComponent} from "react";
import Button, {ButtonProps, ButtonSize, ButtonStyle} from "../../snippet/button/Button";
import {TranslationLibFile} from "../../../utils/locale";
import {useTranslation} from "react-i18next";
import {Action} from "../../../utils/Action";

type ButtonBackProps = Omit<ButtonProps, "children" | "icon" | "reverse"> & {
    noIcon?: boolean;
};

const ButtonBack: FunctionComponent<ButtonBackProps> = ({size, style, noIcon, ...rest}) => {
    const {t} = useTranslation(TranslationLibFile.COMMON);

    return (
        <Button
            size={size || ButtonSize.MEDIUM}
            style={style || ButtonStyle.DEFAULT_MIDNIGHT}
            icon={noIcon ? undefined : Action.BACK.icon}
            {...rest}
        >
            {t(Action.BACK.labelKey)}
        </Button>
    );
};

export default ButtonBack;
